var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-tool-root"},[_c('div',{staticClass:"echarts-body"},[(_vm.showTools)?_c('btnTools',{attrs:{"echartsTitle":_vm.echartsTitle,"echarts-data":_vm.echartsData},on:{"change":function($event){return _vm.change($event)}}}):_vm._e(),_c('div',{staticClass:"echart",attrs:{"id":_vm.echartTagId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }